import React from "react";
import { FormattedMessage } from "react-intl";
import { SortOption } from "../../types/CDIFilter";

interface SortButtonsProps {
	sortBy: SortOption;
	onSortChange: (sort: SortOption) => void;
}

const SortButtons = ({ sortBy, onSortChange }: SortButtonsProps) => {
	return (
		<div className="sort-buttons">
			<button
				className={`sort-button ${sortBy === "relevancy" ? "sort-button-active" : ""}`}
				onClick={() => onSortChange("relevancy")}
			>
				<FormattedMessage id="Relevancy" defaultMessage="Relevancy" />
			</button>
			<button
				className={`sort-button ${sortBy === "popularity" ? "sort-button-active" : ""}`}
				onClick={() => onSortChange("popularity")}
			>
				<FormattedMessage id="Popular" defaultMessage="Popular" />
			</button>
		</div>
	);
};

export default SortButtons;